import React from "react";
import { Link } from "react-router-dom";

function ResultComp({ responseData }) {
  if (
    typeof responseData === "object" &&
    Object.keys(responseData).length === 0
  ) {
    return (
      <div className="m-4 border-[#00C6CA] p-4 border-2 rounded-lg bg-[#00C6CA1A] flex text-[#00C6CA] justify-center">
        Please make a calculation
      </div>
    );
  } else {
    return (
      <div className="m-4 border-[#00C6CA] p-4 border-2 rounded-lg bg-[#00C6CA1A] flex-col text-[#00C6CA] font-montserrat">
        <div
          className=""
          dangerouslySetInnerHTML={{ __html: responseData.data }}
        ></div>
        <div className="flex justify-center mt-4 gap-2">
          {responseData?.actions?.map((item, index) => {
            return (
              <Link to={item?.link}>
                <button className="bg-[#00C6CA] text-white font-montserrat text-xs rounded-[5px] py-1 px-4">
                  {item?.text}
                </button>
              </Link>
            );
          })}
        </div>
      </div>
    );
  }
}
export default ResultComp;
